import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

// Only initialize PostHog in production or when key is available
if (POSTHOG_KEY && typeof window !== "undefined") {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST || "https://us.i.posthog.com",
    // Automatically capture pageviews
    capture_pageview: true,
    // Automatically capture pageleave (tracks time on page)
    capture_pageleave: true,
    // Automatically capture clicks, inputs, etc.
    autocapture: true,
    // Respect Do Not Track browser setting
    respect_dnt: true,
    // Disable in localhost to avoid noise during development
    loaded: (ph) => {
      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
      ) {
        ph.opt_out_capturing();
      }
    },
  });
}

export default posthog;
